import React from "react";
import { Award, Stamp, Users, Clock, FileCheck } from "lucide-react";
import { YOHALY_PHOTO } from "@/lib/company";

const STATS = [
  { icon: Users, value: "500+", label: "Clientes atendidos" },
  { icon: Clock, value: "10+", label: "Años de experiencia" },
  { icon: Award, value: "IRS", label: "Certificación oficial" },
  { icon: FileCheck, value: "CAA", label: "Certifying Agent ITIN" },
];

export default function About() {
  return (
    <section id="nosotros" className="py-24 lg:py-32 bg-white" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-5 reveal">
          <div className="relative">
            <div className="rounded-sm overflow-hidden border border-[#e2e8f0] shadow-lg">
              <img
                src={YOHALY_PHOTO}
                alt="Yohaly Acevedo - Notary Public FL & IRS Certified Tax Preparer"
                className="w-full h-[560px] object-cover object-top"
                data-testid="about-image"
              />
            </div>

            <div className="absolute -bottom-6 -right-6 bg-white border border-[#e2e8f0] p-5 rounded-sm shadow-xl max-w-[240px]">
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 rounded-sm bg-[#C89B2C] flex items-center justify-center">
                  <FileCheck size={22} className="text-[#0f172a]" strokeWidth={1.75} />
                </div>
                <div>
                  <div className="text-[10px] font-bold tracking-[0.15em] text-[#0B2D5C] uppercase">
                    Autorizada
                  </div>
                  <div className="text-sm font-semibold text-[#0f172a]">CAA · ITIN Agent</div>
                </div>
              </div>
            </div>

            <div className="absolute -top-6 -left-6 bg-[#0B2D5C] p-5 rounded-sm shadow-xl">
              <div className="text-[10px] font-bold tracking-[0.15em] text-[#C89B2C] uppercase mb-1">
                IRS Certified
              </div>
              <div className="text-white font-display font-semibold text-lg leading-tight">
                Preparadora de<br />impuestos
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 reveal">
          <div className="text-xs font-semibold text-[#0B2D5C] tracking-[0.2em] uppercase mb-4">
            Conoce a la fundadora
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0f172a] leading-[1.1] mb-3">
            Yohaly Acevedo
          </h2>
          <div className="text-lg text-[#C89B2C] font-semibold mb-6">
            Notary Public FL · IRS Certified · CAA
          </div>

          <p className="text-lg text-[#475569] leading-relaxed mb-5">
            Yohaly Acevedo es <strong className="text-[#0f172a]">Contador Público graduada en Venezuela</strong>,
            radicada en Florida. Es <strong className="text-[#0f172a]">Notary Public en Florida</strong>,{" "}
            <strong className="text-[#0f172a]">especialista en Formularios de Migración</strong> y{" "}
            <strong className="text-[#0f172a]">profesional certificada ante el IRS</strong> en impuestos personales
            y empresariales, además de <strong className="text-[#0f172a]">Certifying Acceptance Agent (CAA)</strong>{" "}
            autorizada para tramitar ITINs directamente ante el IRS.
          </p>
          <p className="text-lg text-[#475569] leading-relaxed">
            Su misión es ayudar a personas, familias y pequeños negocios a cumplir sus obligaciones tributarias,
            fortalecer sus empresas y realizar sus trámites con confianza, ofreciendo un servicio cercano,
            profesional y transparente.
          </p>

          <div className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-4">
            {STATS.map((s, i) => (
              <div
                key={s.label}
                className="border-l-2 border-[#C89B2C] pl-4 py-2"
                data-testid={`about-stat-${i}`}
              >
                <s.icon className="text-[#0B2D5C] mb-2" size={18} strokeWidth={1.75} />
                <div className="font-display text-2xl font-bold text-[#0f172a]">{s.value}</div>
                <div className="text-xs text-[#475569] tracking-wide">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
